<div class="flex flex-column gap-3">
  <form *ngIf="isReady" [formGroup]="form" (ngSubmit)="submit(form)">
    <div class="p-fluid p-formgrid grid">
      <div class="p-field col-12 md:col-6 xl:3 ">
        <label for="lastName">Фамилия</label>
        <input id="lastName" type="text" pInputText formControlName="lastName" class="w-full" />
        <small id="lastName-help" class="p-error" *ngIf="hasErr(form.controls['lastName'], 'required')">Required
          field</small>
      </div>
      <div class="p-field col-12 md:col-6 xl:3">
        <label for="firstName">Имя</label>
        <input id="firstName" type="text" pInputText formControlName="firstName" class="w-full" />
        <small id="firstName-help" class="p-error" *ngIf="hasErr(form.controls['firstName'], 'required')">Required
          field</small>
      </div>
      <div class="p-field col-12 md:col-6 xl:3">
        <label for="middleName">Отчество</label>
        <input id="middleName" type="text" pInputText formControlName="middleName" class="w-full" />
        <small id="middleName-help" class="p-error" *ngIf="hasErr(form.controls['middleName'], 'required')">Required
          field</small>
      </div>
      <div class="p-field col-12 md:col-6 xl:3">
        <label for="contactEmail">Email</label>
        <input id="contactEmail" type="text" pInputText formControlName="contactEmail" class="w-full" />
        <small id="contactEmail-help" class="p-error" *ngIf="hasErr(form.controls['contactEmail'], 'required')">Required
          field</small>
        <small id="contactEmail-help2" class="p-error" *ngIf="hasErr(form.controls['contactEmail'], 'email')">Not valid
          email</small>
      </div>
      <div class="p-field col-12">
        <label for="workplace">Место работы</label>
        <input id="workplace" type="text" pInputText formControlName="workplace" class="w-full" />
        <small id="workplace-help" class="p-error" *ngIf="hasErr(form.controls['workplace'], 'required')">Required
          field</small>
      </div>
      <div class="col-12">
        <!-- <pre>{{ form.value | json }}</pre> -->
        <!-- <hr> -->
        <div class="flex flex-row gap-3 justify-content-start">
          <button pButton class="p-button-success" icon="pi pi-check" label="Сохранить" (click)="submit(form)"
          ></button>
          <button pButton type="button" icon="pi pi-ban" class="p-button-secondary" label="Закрыть"
          (click)="cancel()"></button>
        </div>
      </div>
    </div>
  </form>

</div>
